'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

function _interopNamespace(e) {
    if (e && e.__esModule) { return e; } else {
        var n = {};
        if (e) {
            Object.keys(e).forEach(function (k) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            });
        }
        n['default'] = e;
        return n;
    }
}

var core = require('@material-ui/core');
var clsx = _interopDefault(require('clsx'));
var React = _interopDefault(require('react'));
var HTTPStatusCodes = _interopDefault(require('http-status-codes'));
require('react-localize-redux');
var moment = _interopDefault(require('moment'));

const useStyles = core.makeStyles((theme) => core.createStyles({
    iconTextContainer: {
        flexWrap: "nowrap",
    },
    icon: ({ iconColor, ...props }) => ({
        marginRight: theme.spacing(1),
        width: props.IconProps?.width ?? "36px",
        height: props.IconProps?.height ?? "36px",
        color: iconColor,
    }),
    textContainer: {
        minWidth: 0,
    },
    text: ({ variant }) => ({
        lineHeight: "1.2em",
        fontWeight: 500,
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: variant === "vertical" ? "center" : "inherit",
    }),
    caption: ({ variant }) => ({
        lineHeight: "1.2em",
        fontWeight: 400,
        textAlign: variant === "vertical" ? "center" : "inherit",
    }),
}));
function IconText(props) {
    const classes = useStyles(props);
    if (!props.Icon && !props.IconElement) {
        throw new Error("Either Icon or IconElement props must be set.");
    }
    return (React.createElement(core.Grid, { className: classes.iconTextContainer, container: true, alignItems: "center", direction: props.variant === "vertical" ? "column" : "row" },
        React.createElement(core.Grid, { item: true }, props.IconElement
            ? props.IconElement
            : props.Icon && (React.createElement(props.Icon, Object.assign({ color: props.iconColor ? "inherit" : undefined }, props.IconProps, { className: clsx(classes.icon, props.IconProps?.className) })))),
        React.createElement(core.Grid, { className: classes.textContainer, item: true },
            React.createElement(core.Grid, { container: true, direction: props.reverse ? "column-reverse" : "column" },
                React.createElement(core.Grid, { item: true }, props.disableTextTypography ? (props.text) : (React.createElement(core.Typography, Object.assign({ component: "span", color: "textPrimary" }, props.TextProps, { className: clsx(classes.text, props.TextProps?.className) }), props.text))),
                React.createElement(core.Grid, { item: true }, props.disableCaptionTypography ? (props.caption) : (React.createElement(core.Typography, Object.assign({ component: "span", variant: "subtitle2" }, props.CaptionProps, { className: clsx(classes.caption, props.CaptionProps?.className) }), props.caption)))))));
}

const AddressIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#F5681E" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.33329 12.5514L13 10.5517V19.2663L9.33329 21.2661V12.5514ZM13.5 21C13.3222 21 13.1661 20.8764 13.0774 20.69L8.9975 22.9156C8.55334 23.1573 8 22.8511 8 22.3628V12.1823C8 11.9541 8.12833 11.7433 8.33583 11.6296L13.0025 9.08446C13.1324 9.0139 13.2819 8.98788 13.4265 9.00715C13.4505 9.00244 13.475 9 13.5 9C13.6242 9 13.7378 9.06029 13.8252 9.16013L18.1317 11.2156C18.2231 11.083 18.3542 11 18.5 11C18.6778 11 18.8339 11.1236 18.9226 11.31L23.0025 9.08445C23.4467 8.84266 24 9.14887 24 9.63721V19.8177C24 20.0459 23.8717 20.2567 23.6642 20.3704L18.9975 22.9155C18.8676 22.9861 18.7181 23.0121 18.5735 22.9929C18.5495 22.9976 18.525 23 18.5 23C18.3758 23 18.2622 22.9397 18.1748 22.8399L13.8683 20.7844C13.7769 20.917 13.6458 21 13.5 21ZM19 21.4483L22.6666 19.4487V10.734L19 12.7337V21.4483ZM18 12.576V21.3333L14 19.4242V10.6668L18 12.576Z", fill: props.color ?? props.htmlColor ?? "#F5681E" })));

const ExperienceIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#44D6E9" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.463 11.3588C11.5422 12.2133 11.0175 13.367 11.0004 14.5746L11.0005 14.5746C10.9774 16.0257 11.6929 17.4015 12.933 18.2878C13.3841 18.6282 13.6434 19.1416 13.6365 19.6811V20.8816C13.6365 21.1006 13.8231 21.2799 14.0593 21.2878H17.9438C18.1783 21.2791 18.3641 21.0998 18.3641 20.8816V19.6811C18.3572 19.1424 18.6157 18.6306 19.0676 18.2918C20.2187 17.4627 20.9222 16.2099 20.9941 14.8595C21.0651 13.5097 20.4968 12.199 19.4381 11.2699C18.4916 10.4392 17.2335 9.98378 15.9309 10.0004C14.6283 10.0171 13.3839 10.5043 12.463 11.3588ZM17.3147 23H14.6856C14.4425 23 14.2474 22.4113 14.2474 22.1875V22.0979H17.7529V22.1875C17.7529 22.4113 17.5561 23 17.3147 23Z", fill: props.color ?? props.htmlColor ?? "#44D6E9" })));

const FbIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { d: "M16.625 13.1875V10.9375C16.625 10.3165 17.129 9.8125 17.75 9.8125H18.875V7H16.625C14.7609 7 13.25 8.51088 13.25 10.375V13.1875H11V16H13.25V25H16.625V16H18.875L20 13.1875H16.625Z", fill: props.color ?? props.htmlColor ?? "#3A559F" }),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#3A559F" })));

const GoogleCalendarIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "186 38 76 76" }, props),
    React.createElement("path", { fill: "#fff", d: "M244 56h-40v40h40V56z" }),
    React.createElement("path", { fill: "#EA4335", d: "M244 114l18-18h-18v18z" }),
    React.createElement("path", { fill: "#FBBC04", d: "M262 56h-18v40h18V56z" }),
    React.createElement("path", { fill: "#34A853", d: "M244 96h-40v18h40V96z" }),
    React.createElement("path", { fill: "#188038", d: "M186 96v12c0 3.315 2.685 6 6 6h12V96h-18z" }),
    React.createElement("path", { fill: "#1967D2", d: "M262 56V44c0-3.315-2.685-6-6-6h-12v18h18z" }),
    React.createElement("path", { fill: "#4285F4", d: "M244 38h-52c-3.315 0 -6 2.685-6 6v52h18V56h40V38z" }),
    React.createElement("path", { fill: "#4285F4", d: "M212.205 87.03c-1.495-1.01-2.53-2.485-3.095-4.435l3.47-1.43c.315 1.2.865 2.13 1.65 2.79.78.66 1.73.985 2.84.985 1.135 0 2.11-.345 2.925-1.035s1.225-1.57 1.225-2.635c0-1.09-.43-1.98-1.29-2.67-.86-.69-1.94-1.035-3.23-1.035h-2.005V74.13h1.8c1.11 0 2.045-.3 2.805-.9.76-.6 1.14-1.42 1.14-2.465 0 -.93-.34-1.67-1.02-2.225-.68-.555-1.54-.835-2.585-.835-1.02 0 -1.83.27-2.43.815a4.784 4.784 0 0 0 -1.31 2.005l-3.435-1.43c.455-1.29 1.29-2.43 2.515-3.415 1.225-.985 2.79-1.48 4.69-1.48 1.405 0 2.67.27 3.79.815 1.12.545 2 1.3 2.635 2.26.635.965.95 2.045.95 3.245 0 1.225-.295 2.26-.885 3.11-.59.85-1.315 1.5-2.175 1.955v.205a6.605 6.605 0 0 1 2.79 2.175c.725.975 1.09 2.14 1.09 3.5 0 1.36-.345 2.575-1.035 3.64s-1.645 1.905-2.855 2.515c-1.215.61-2.58.92-4.095.92-1.755.005-3.375-.5-4.87-1.51zM233.52 69.81l-3.81 2.755-1.905-2.89 6.835-4.93h2.62V88h-3.74V69.81z" })));

const GoogleCalendarIconOld = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 272.23 272.22" }, props),
    React.createElement("path", { d: "M72.16,10a10.63,10.63,0,0,1,6.21.54,9.74,9.74,0,0,1,5.56,6.83,10.81,10.81,0,0,1-.82,6.23A9.55,9.55,0,0,1,72.32,28.7a9.84,9.84,0,0,1-7.48-9.52A9.67,9.67,0,0,1,72.16,10Z", fill: "#fff" }),
    React.createElement("path", { d: "M195.46,10a10.5,10.5,0,0,1,6.27.62,9.81,9.81,0,0,1,5.61,8.22,10.12,10.12,0,0,1-2.88,7.33A9.64,9.64,0,0,1,197.94,29a9.74,9.74,0,0,1-9-5.68c-1-1.86-.83-4-.71-6A9.72,9.72,0,0,1,195.46,10Z", fill: "#fff" }),
    React.createElement("path", { d: "M183.09,155.72c4.88,0,9.76,0,14.63,0-.06,19.38,0,38.77,0,58.16H183.12C183.11,194.49,183.16,175.1,183.09,155.72Z", fill: "#fff" }),
    React.createElement("path", { d: "M25,1.49A22.68,22.68,0,0,1,34.76,0h205a19.4,19.4,0,0,1,19.49,20c0,6.64.07,13.28,0,19.92a19.61,19.61,0,0,0-6.92-1.07H20.34a21.3,21.3,0,0,0-7.27,1.07C13,33,13,26.1,13,19.2A19.37,19.37,0,0,1,25,1.49ZM72.16,10a9.67,9.67,0,0,0-7.32,9.22,9.84,9.84,0,0,0,7.48,9.52,9.55,9.55,0,0,0,10.79-5.14,10.81,10.81,0,0,0,.82-6.23,9.74,9.74,0,0,0-5.56-6.83A10.63,10.63,0,0,0,72.16,10Zm123.3,0a9.72,9.72,0,0,0-7.21,7.32c-.12,2-.24,4.17.71,6a9.74,9.74,0,0,0,9,5.68,9.64,9.64,0,0,0,6.52-2.86,10.12,10.12,0,0,0,2.88-7.33,9.81,9.81,0,0,0-5.61-8.22A10.5,10.5,0,0,0,195.46,10Z", fill: "#c7c7c7" }),
    React.createElement("path", { d: "M194.32,97.53a7.42,7.42,0,0,1,3.44-.34c-.07,19.45,0,38.9,0,58.35v.18c-4.87,0-9.75,0-14.63,0v-.17q0-20.18,0-40.34c-9.72,3.23-19.43,6.52-29.15,9.73,0-4.39,0-8.78,0-13.17C167.36,107,180.86,102.3,194.32,97.53Z", fill: "#c7c7c7" }),
    React.createElement("path", { d: "M75.32,104.52a37.69,37.69,0,0,1,21.34-7.33c7.55-.26,15.37,1,22,4.8a27.33,27.33,0,0,1,11.62,13.37A36.4,36.4,0,0,1,132.53,133c-1.46,9.54-8.83,17.25-17.43,21.06a21.94,21.94,0,0,1,3.57,1.42,10.93,10.93,0,0,1-2.28.2c-10.16-.07-20.32.07-30.47-.07,0-2.2-.09-4.41,0-6.61,7.32-.18,15,.72,21.9-2.49a17.8,17.8,0,0,0,10.61-13.84c.68-5.79.1-12.12-3.34-17-2.69-3.88-7.27-6-11.84-6.7-6.17-.87-12.94-.25-18.12,3.5-5.1,3.58-7.8,9.91-7.67,16.06-4.7.12-9.4,0-14.11,0a34.13,34.13,0,0,1,1-7.67A29.72,29.72,0,0,1,75.32,104.52Z", fill: "#c7c7c7" }),
    React.createElement("path", { d: "M13.07,39.9a21.3,21.3,0,0,1,7.27-1.07H252.27a19.61,19.61,0,0,1,6.92,1.07c6.68,2.41,12.09,8.6,12.79,15.77a20.65,20.65,0,0,0-8.69-12.19,19.91,19.91,0,0,0-10.65-3.1q-116.32.08-232.68.05a19.71,19.71,0,0,0-15.45,7c-1.8,1.93-2.75,4.42-4,6.7A19.41,19.41,0,0,1,13.07,39.9Z", fill: "#4483ef" }),
    React.createElement("path", { d: "M182.82,155.57l.27,0v.17c.07,19.38,0,38.77,0,58.15H197.7c0-19.39,0-38.78,0-58.16v-.18l.24,0a60.51,60.51,0,0,0,6.46.13q27.41,0,54.81,0c2.11,30.55,4.1,61.11,6.19,91.66.2,3.49.64,7.08-.32,10.5L265,258a17.49,17.49,0,0,0-2.05,3.43,19.47,19.47,0,0,1-16.41,9.29q-109.32-.06-218.63,0a26.11,26.11,0,0,1-6.84-.48,19.76,19.76,0,0,1-12.14-9.28A18.58,18.58,0,0,0,7.2,258l-.09-.12c-1.22-4.58-.23-9.32-.07-14C9,214.51,11,185.12,13,155.73q36.44-.09,72.87,0c0,1.4,0,2.8,0,4.19,7.69.15,15.75-.77,23,2.28a17.78,17.78,0,0,1,10.52,11.12,27.61,27.61,0,0,1-.5,17.37,17.74,17.74,0,0,1-11.63,10.72,29.28,29.28,0,0,1-19.65-.91,18,18,0,0,1-10.17-11.19,24.12,24.12,0,0,1-1-6.85c-4.66,0-9.31,0-14,0A29.45,29.45,0,0,0,82.2,210.91a46.46,46.46,0,0,0,23.88,2.38c7.76-1.23,15.36-4.7,20.63-10.65a31.62,31.62,0,0,0,7.68-19.73c.45-6.85-1.13-14-5.47-19.47a31.52,31.52,0,0,0-9.24-7.59,40.36,40.36,0,0,1,5-.15q25.82,0,51.63,0C178.5,155.65,180.67,155.82,182.82,155.57Z", fill: "#4483ef" }),
    React.createElement("path", { d: "M4.51,47.39a19.71,19.71,0,0,1,15.45-7q116.35,0,232.68-.05a19.91,19.91,0,0,1,10.65,3.1A20.65,20.65,0,0,1,272,55.66a16.41,16.41,0,0,1,.08,5.28c-4.22,31.57-8.58,63.11-12.74,94.68-17.53,0-35.07,0-52.59,0-2.93,0-5.85.11-8.77-.05l-.24,0c.05-19.45,0-38.9,0-58.35a7.42,7.42,0,0,0-3.44.34c-13.46,4.77-27,9.44-40.41,14.24.05,4.39,0,8.78,0,13.17,9.72-3.21,19.43-6.5,29.15-9.73q0,20.17,0,40.34l-.27,0c-20.37.15-40.75,0-61.12.08-1,0-2.07.29-3-.13a21.94,21.94,0,0,0-3.57-1.42c8.6-3.81,16-11.52,17.43-21.06a36.4,36.4,0,0,0-2.27-17.68A27.33,27.33,0,0,0,118.64,102c-6.61-3.84-14.43-5.06-22-4.8a37.69,37.69,0,0,0-21.34,7.33,29.72,29.72,0,0,0-11,16.4,34.13,34.13,0,0,0-1,7.67c4.71,0,9.41.08,14.11,0-.13-6.15,2.57-12.48,7.67-16.06,5.18-3.75,11.95-4.37,18.12-3.5,4.57.68,9.15,2.82,11.84,6.7,3.44,4.9,4,11.23,3.34,17a17.8,17.8,0,0,1-10.61,13.84C101,149.76,93.29,148.86,86,149h-.18c.08,2.21,0,4.42,0,6.62q-36.45,0-72.91,0Q6.72,109.29.41,62.91A21.66,21.66,0,0,1,.5,54.09C1.76,51.81,2.71,49.32,4.51,47.39Z", fill: "#3664d0" }),
    React.createElement("path", { d: "M7.2,258a18.58,18.58,0,0,1,1.74,2.95,19.76,19.76,0,0,0,12.14,9.28,26.11,26.11,0,0,0,6.84.48q109.32,0,218.63,0A19.47,19.47,0,0,0,263,261.39,17.49,17.49,0,0,1,265,258a19.32,19.32,0,0,1-12.75,13.32c-3.41,1.19-7.08.89-10.62.93H28.69a26.49,26.49,0,0,1-8.46-.84A19.36,19.36,0,0,1,7.2,258Z", fill: "#3664d0" })));

const GoogleMeetIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ width: "175", height: "144", fill: "none", version: "1.1", viewBox: "0 0 175 144" }, props),
    React.createElement("g", { transform: "matrix(2,0,0,2,-9,-24)" },
        React.createElement("path", { d: "m54 48 8.53 9.75 11.47 7.33 2-17.015-2-16.64-11.69 6.44z", fill: "#00832d" }),
        React.createElement("path", { d: "m4.5 63.5v14.5c0 3.315 2.685 6 6 6h14.5l3-10.96-3-9.54-9.95-3z", fill: "#0066da" }),
        React.createElement("path", { d: "m25 12-20.5 20.5 10.55 3 9.95-3 2.95-9.415z", fill: "#e94235" }),
        React.createElement("path", { d: "m25 32.5h-20.5v31h20.5z", fill: "#2684fc" }),
        React.createElement("path", { d: "m87.095 20.68-13.095 10.745v33.655l13.15 10.785c1.97 1.54 4.85.135 4.85-2.365v-50.5c0-2.535-2.945-3.925-4.905-2.32z", fill: "#00ac47" }),
        React.createElement("path", { d: "m54 48v15.5h-29v20.5h43c3.315 0 6-2.685 6-6v-12.92z", fill: "#00ac47" }),
        React.createElement("path", { d: "m68 12h-43v20.5h29v15.5l20-16.575v-13.425c0-3.315-2.685-6-6-6z", fill: "#ffba00" }))));

const GoogleMeetIconOld = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 256 297" }, props),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "a", x1: "-290.6", y1: "445.09", x2: "-290.11", y2: "445.58", gradientTransform: "matrix(255.95, 0, 0, -296.14, 74446.62, 132010.4)", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { offset: "0", "stop-color": "#058b7e" }),
            React.createElement("stop", { offset: "0", "stop-color": "#058d80" }),
            React.createElement("stop", { offset: "1", "stop-color": "#058d7f" })),
        React.createElement("mask", { id: "b", x: "0", y: "0", width: "311.89", height: "296.14", maskUnits: "userSpaceOnUse" },
            React.createElement("path", { d: "M127.68,0C57.17,0,0,55.79,0,124.61S57.17,249.22,127.68,249.22l.27,46.92c65.61-37.27,128-87,128-171.53C256,55.79,198.2,0,127.68,0Z", fill: "#fff" })),
        React.createElement("linearGradient", { id: "c", x1: "-290.55", y1: "445.26", x2: "-290.03", y2: "444.68", gradientTransform: "matrix(253.58, 0, 0, -199.59, 73810.76, 89002.79)", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { offset: "0" }),
            React.createElement("stop", { offset: "1", "stop-color": "#d8d8d8", "stop-opacity": "0" }))),
    React.createElement("title", null, "google_meet"),
    React.createElement("path", { d: "M127.68,0C57.17,0,0,55.79,0,124.61S57.17,249.22,127.68,249.22l.27,46.92c65.61-37.27,128-87,128-171.53C256,55.79,198.2,0,127.68,0Z", fill: "url(#a)" }),
    React.createElement("g", { mask: "url(#b)" },
        React.createElement("polygon", { points: "58.32 168.56 167.35 281.28 311.89 175.62 207.44 81.7 185.11 119.97 58.32 168.56", fillOpacity: "0.20999999344348907", fill: ":url(#c)" })),
    React.createElement("path", { d: "M55.58,128.11v34.23A16.49,16.49,0,0,0,72,178.78h85a16.49,16.49,0,0,0,16.44-16.44V140.72l33.65,33.66V128.11Z" }),
    React.createElement("path", { d: "M55.58,128.11v34.23A16.49,16.49,0,0,0,72,178.78h85a16.49,16.49,0,0,0,16.44-16.44V140.72l33.65,33.66V128.11Z", fill: "#f6f6f6", fillRule: "evenodd" }),
    React.createElement("path", { d: "M207.12,128.11V81.7l-33.65,33.59V93.87A16.49,16.49,0,0,0,157,77.43H72A16.49,16.49,0,0,0,55.58,93.87v34.24Z", fill: "#e2e2e2" })));

const LanguagesIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { d: "M17.9529 10.1176L17.6988 8.84706C17.6035 8.36 17.1694 8 16.6612 8H9.05882C8.47647 8 8 8.47647 8 9.05882V24.9412C8 25.5235 8.47647 26 9.05882 26C9.64118 26 10.1176 25.5235 10.1176 24.9412V18.5882H16.0471L16.3012 19.8588C16.3965 20.3565 16.8306 20.7059 17.3388 20.7059H22.8235C23.4059 20.7059 23.8824 20.2294 23.8824 19.6471V11.1765C23.8824 10.5941 23.4059 10.1176 22.8235 10.1176H17.9529Z", fill: props.color ?? props.htmlColor ?? "#4CAF50" }),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#4CAF50" })));

const MailIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#F73E5F" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.45121 10.1763L14.4803 15.4918C15.3745 16.1685 16.625 16.1685 17.5193 15.4918L24.5484 10.1763C24.0641 9.46922 23.2381 9 22.299 9H9.6997C8.76151 9 7.93551 9.46922 7.45121 10.1763ZM25 12.0522L18.6239 16.874C17.852 17.4572 16.9263 17.7501 16 17.7501C15.0737 17.7501 14.1481 17.4572 13.3761 16.874L7 12.0522V20.375C7 21.822 8.21159 23 9.69991 23H22.3001C23.7884 23 25 21.822 25 20.375V12.0522Z", fill: props.color ?? props.htmlColor ?? "#F73E5F" })));

const OnlineIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { d: "M23.2 8H8.8C7.81 8 7.009 8.81 7.009 9.8L7 26L10.6 22.4H23.2C24.19 22.4 25 21.59 25 20.6V9.8C25 8.81 24.19 8 23.2 8ZM19.942 17.63L17.8 15.92V17.9C17.8 18.395 17.395 18.8 16.9 18.8H11.5C11.005 18.8 10.6 18.395 10.6 17.9V12.5C10.6 12.005 11.005 11.6 11.5 11.6H16.9C17.395 11.6 17.8 12.005 17.8 12.5V14.48L19.942 12.77C20.527 12.302 21.4 12.716 21.4 13.472V16.928C21.4 17.684 20.527 18.098 19.942 17.63V17.63Z", fill: props.color ?? props.htmlColor ?? "#E91D62" }),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#E91D62" })));

const PhoneIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#70D351" }),
    React.createElement("path", { d: "M17.9144 19.3701C18.1248 19.1078 18.8599 17.8993 19.9625 18.2675C21.1177 18.6351 24.0066 19.6331 22.641 21.4189C18.0722 27.6157 4.41815 13.9093 10.5618 9.33977C12.3475 8.02678 13.3449 10.8625 13.7132 12.0183C14.0807 13.1735 12.9255 13.8566 12.6106 14.0663C11.823 14.8014 17.2321 20.1585 17.9152 19.3709L17.9144 19.3701Z", fill: props.color ?? props.htmlColor ?? "#70D351" })));

const PinIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 45 60" }, props),
    React.createElement("g", { id: "PinIcon", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "PinIcon-ig", transform: "translate(-157.000000, -297.000000)", fill: props.htmlColor ?? (props.color ? "currentColor" : "#0070E1"), fillRule: "nonzero" },
            React.createElement("path", { d: "M179.315395,304.003598 C177.245509,303.959282 175.266918,304.324235 173.376952,305.103641 C171.554724,305.838783 169.930635,306.904926 168.504685,308.307408 C167.10216,309.70989 166.012493,311.310438 165.235685,313.111722 C164.411895,315.001629 164,316.969749 164,319.018749 C164,321.02077 164.401458,322.944578 165.201783,324.790173 C165.957769,326.591458 167.016204,328.181595 168.371747,329.560587 C169.750781,330.963069 171.320146,332.042291 173.077174,332.798254 C174.902005,333.598528 176.802381,334 178.783642,334 C180.874349,334 182.866021,333.611588 184.755986,332.832155 C186.557326,332.076192 188.160594,331.009983 189.56045,329.628389 C190.962975,328.249397 192.042231,326.66967 192.798217,324.889207 C193.598516,323.020121 194,321.062412 194,319.01608 C194,317.01406 193.622,315.090252 192.866021,313.244656 C192.110034,311.464193 191.064681,309.887135 189.729959,308.505474 C188.374416,307.126483 186.815461,306.04726 185.058434,305.267807 C183.231,304.470136 181.317544,304.047843 179.315461,304.003531 L179.315395,304.003598 Z M201.00973,326.08098 C200.233427,328.634813 199.029927,331.001241 197.4097,333.177331 L179.938374,356.435078 C179.89409,356.502762 179.839384,356.59128 179.771657,356.700618 C179.703929,356.833388 179.649226,356.934915 179.604939,357 L179.370494,357 C179.237641,356.73446 179.13605,356.544422 179.070923,356.432478 L161.633608,333.205389 C157.853789,328.162767 156.387209,322.521541 157.231199,316.278911 C157.520348,314.034843 158.16375,311.879279 159.164055,309.814886 C160.12008,307.794745 161.365259,305.948947 162.899594,304.282824 C164.433928,302.616701 166.16619,301.216091 168.101713,300.083661 C169.946008,298.972023 171.891935,298.172817 173.936825,297.683377 C177.516049,296.772208 181.217711,296.772208 185.038876,297.683377 C189.305776,298.750762 192.997301,300.958375 196.11025,304.314014 C197.933739,306.26911 199.345636,308.479322 200.345941,310.944651 C201.32544,313.344935 201.867205,315.831057 201.979239,318.408216 C202.088646,321.014166 201.765634,323.570599 201.01021,326.08038 L201.00973,326.08098 Z", id: "Shape" })))));

const PriceIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#0070E1" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1001 10.3023C12.1001 10.1352 12.2385 10 12.4096 10C12.5807 10 12.7191 10.1352 12.7191 10.3023V12.8721C12.7191 13.0392 12.5807 13.1744 12.4096 13.1744C12.2385 13.1744 12.1001 13.0392 12.1001 12.8721V10.3023ZM18.2905 10.3023C18.2905 10.1352 18.4289 10 18.6 10C18.7711 10 18.9095 10.1352 18.9095 10.3023V12.8721C18.9095 13.0392 18.7711 13.1744 18.6 13.1744C18.4289 13.1744 18.2905 13.0392 18.2905 12.8721V10.3023ZM10.2429 10.907C9.55496 10.907 9 11.449 9 12.121V14.8372H21.9999V12.121C21.9999 11.449 21.445 10.907 20.757 10.907H19.2191V12.1966C19.4089 12.3625 19.5286 12.6034 19.5286 12.8721C19.5286 13.3728 19.1127 13.7791 18.6 13.7791C18.0874 13.7791 17.6715 13.3728 17.6715 12.8721C17.6715 12.6034 17.7912 12.3625 17.981 12.1966V10.907H13.0238V12.1919C13.2167 12.3578 13.3382 12.6011 13.3382 12.8721C13.3382 13.3728 12.9223 13.7791 12.4096 13.7791C11.897 13.7791 11.4811 13.3728 11.4811 12.8721C11.4811 12.6058 11.5989 12.3672 11.7857 12.2013V10.907H10.2429ZM9 21.786V15.4418H22V21.786C22 22.4579 21.445 23 20.7571 23H10.2429C9.55496 23 9 22.4579 9 21.786Z", fill: props.color ?? props.htmlColor ?? "#0070E1" })));

const RatingIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#FFD432" }),
    React.createElement("path", { d: "M16.3686 10.2253L18.1755 13.956C18.2199 14.085 18.308 14.1707 18.4399 14.1707L22.6701 14.6853C22.9789 14.7284 23.1108 15.114 22.8907 15.3287L19.7619 18.1588C19.6738 18.2445 19.6295 18.3734 19.6738 18.5018L20.467 22.5756C20.5551 22.8761 20.2026 23.0902 19.9382 22.9618L16.1926 20.9462C16.0601 20.9031 15.9282 20.9031 15.8401 20.9462L12.0944 22.9618C11.83 23.0907 11.4775 22.8761 11.5656 22.5756L12.3588 18.5018C12.3588 18.3729 12.3145 18.2445 12.2263 18.1588L9.14183 15.3287C8.87744 15.1141 9.00936 14.7284 9.31808 14.6853L13.5483 14.1707C13.6808 14.1707 13.8127 14.0849 13.857 13.956L15.664 10.2253C15.7964 9.9249 16.2371 9.9249 16.369 10.2253H16.3686Z", fill: props.color ?? props.htmlColor ?? "#FFD432" })));

const SiteIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#006DF0" }),
    React.createElement("g", { clipPath: "url(#clip0)" },
        React.createElement("path", { d: "M21.5273 14.53C21.0098 11.9425 18.7373 10 16.0073 10C13.8398 10 11.9573 11.23 11.0198 13.03C8.76232 13.27 7.00732 15.1825 7.00732 17.5C7.00732 19.9825 9.02482 22 11.5073 22H21.2573C23.3273 22 25.0073 20.32 25.0073 18.25C25.0073 16.27 23.4698 14.665 21.5273 14.53V14.53Z", fill: props.color ?? props.htmlColor ?? "#006DF0" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0" },
            React.createElement("rect", { x: "7", y: "7", width: "18", height: "18", fill: "white" })))));

const SkypeIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { d: "M24.2486 17.303C24.3158 16.8781 24.3512 16.4433 24.3512 15.9995C24.3512 11.3872 20.6123 7.64844 15.9997 7.64844C15.5571 7.64844 15.1211 7.68489 14.6965 7.75131C13.9273 7.27541 13.0195 7 12.0466 7C9.25949 7 7 9.25915 7 12.0465C7 13.0192 7.27558 13.9262 7.75128 14.6969C7.68545 15.1226 7.64921 15.5559 7.64921 15.9997C7.64921 20.6124 11.388 24.35 15.9995 24.35C16.4425 24.35 16.8787 24.3159 17.3032 24.2489C18.0732 24.7238 18.9802 25 19.9529 25C22.7408 25 25 22.7403 25 19.953C25.0002 18.98 24.7248 18.0731 24.2486 17.303ZM19.9648 19.7977C19.6115 20.3063 19.0925 20.7037 18.4144 20.9895C17.7349 21.2761 16.9318 21.4186 16.0043 21.4186C14.8927 21.4186 13.9723 21.2241 13.2459 20.8313C12.7309 20.5501 12.3121 20.1728 11.9901 19.7023C11.6674 19.2314 11.5038 18.7703 11.5038 18.3206C11.5038 18.0554 11.605 17.8247 11.8019 17.6367C12.0008 17.4472 12.2571 17.3523 12.5595 17.3523C12.8073 17.3523 13.0201 17.4269 13.1933 17.5747C13.3653 17.7225 13.5096 17.9374 13.6275 18.221C13.7689 18.5495 13.9225 18.8241 14.086 19.0432C14.2484 19.2596 14.477 19.4403 14.773 19.5817C15.0658 19.7235 15.4554 19.7944 15.943 19.7944C16.6103 19.7944 17.1496 19.65 17.5623 19.3653C17.9771 19.078 18.1764 18.7284 18.1764 18.3059C18.1764 17.969 18.0689 17.7014 17.8486 17.4928C17.6263 17.2815 17.3392 17.1205 16.983 17.0083C16.6253 16.8948 16.1452 16.7745 15.5434 16.6477C14.7354 16.4714 14.0596 16.2661 13.5123 16.0304C12.9643 15.7938 12.5279 15.4703 12.2045 15.0618C11.8804 14.6492 11.7187 14.1364 11.7187 13.529C11.7187 12.9498 11.8894 12.4318 12.2309 11.981C12.5723 11.529 13.0663 11.183 13.7104 10.942C14.3522 10.701 15.1077 10.5805 15.9734 10.5805C16.6656 10.5805 17.2644 10.6606 17.7712 10.82C18.2767 10.9805 18.698 11.1924 19.0349 11.4582C19.3697 11.7234 19.616 12.0032 19.772 12.2967C19.9279 12.5912 20.0064 12.8788 20.0064 13.1594C20.0064 13.4203 19.9052 13.657 19.7081 13.8644C19.5111 14.0721 19.259 14.178 18.9646 14.177C18.6991 14.177 18.4909 14.1158 18.3466 13.9862C18.2059 13.8608 18.0583 13.6612 17.8985 13.383C17.6966 12.9948 17.4548 12.6923 17.1735 12.476C16.8997 12.2637 16.4479 12.1532 15.8193 12.1545C15.2377 12.1545 14.7723 12.2734 14.4211 12.5058C14.0677 12.742 13.8987 13.0159 13.8979 13.337C13.8985 13.5381 13.9563 13.7077 14.0727 13.8528C14.1909 13.9992 14.3553 14.126 14.5667 14.2329C14.7781 14.3415 14.9932 14.4255 15.2093 14.486C15.4279 14.5479 15.7907 14.6375 16.295 14.7562C16.9274 14.8925 17.5011 15.0448 18.0165 15.2107C18.531 15.3775 18.97 15.5787 19.3327 15.8184C19.6983 16.0573 19.9841 16.362 20.1881 16.73C20.3935 17.0985 20.4958 17.5487 20.4958 18.0784C20.4966 18.7163 20.3189 19.2899 19.9648 19.7977Z", fill: props.color ?? props.htmlColor ?? "#006DF0" }),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#006DF0" })));

const SpecialistsIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 25 23" }, props),
    React.createElement("path", { d: "M9.0004,13C13.9712,13 18.0008,16.5945 18,21.0301C18,23.6566 0,23.6566 0,21.0301C0,16.5945 4.0296,13 9.0004,13ZM23.125,17.1818C24.1602,17.1818 25,18.0369 25,19.0909C25,20.1449 24.1602,21 23.125,21L23.125,21L22.9785,20.9943C22.0117,20.9181 21.25,20.0947 21.25,19.0909C21.25,18.0369 22.0898,17.1818 23.125,17.1818ZM23.125,8.5909C24.1602,8.5909 25,9.446 25,10.5C25,11.554 24.1602,12.4091 23.125,12.4091L23.125,12.4091L18.7693,12.4091C17.7342,12.4091 16.8943,11.554 16.8943,10.5C16.8943,9.446 17.7342,8.5909 18.7693,8.5909L18.7693,8.5909ZM10.5299,4.3055C12.5703,5.1507 13.5398,7.4899 12.6947,9.5304C11.8495,11.571 9.5097,12.5397 7.4701,11.6945C5.4297,10.8493 4.4602,8.5101 5.3053,6.4696C6.1505,4.429 8.4903,3.4603 10.5299,4.3055ZM23.125,0C24.1602,0 25,0.8551 25,1.9091C25,2.9631 24.1602,3.8182 23.125,3.8182L23.125,3.8182L15.6246,3.8182C14.5894,3.8182 13.7496,2.9631 13.7496,1.9091C13.7496,0.8551 14.5894,0 15.6246,0L15.6246,0Z", fill: props.color ?? props.htmlColor ?? "?attr/colorPrimary", stroke: "#00000000", strokeWidth: "1" })));

const TimeAgoIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M18.3275 6.56423C18.2675 6.29889 17.9359 6.21083 17.7408 6.40191L17.1687 6.96195C14.3543 4.32415 9.86903 4.33903 7.09937 7.05001C4.30021 9.80584 4.30021 14.27 7.09937 17.0109C7.26517 17.1733 7.43037 17.3206 7.61086 17.468C7.73138 17.5566 7.8666 17.6003 8.00242 17.6003C8.18291 17.6003 8.34871 17.5267 8.46924 17.3793C8.67971 17.1289 8.64973 16.7456 8.39398 16.5396C8.24348 16.4216 8.10826 16.3036 7.97244 16.1712C5.63956 13.8873 5.63956 10.1886 7.97244 7.91977C10.26 5.66522 13.9628 5.6359 16.2957 7.81675L15.6031 8.49478C15.4074 8.68645 15.4979 9.01049 15.7689 9.06919L18.5687 9.73225C18.8244 9.79096 19.0502 9.56994 18.9902 9.31956L18.3275 6.56423ZM13.2219 17.7763L13.2219 17.7763L13.2219 17.7763L13.2219 17.7763L13.2219 17.7763C13.1679 17.7876 13.1139 17.7989 13.0598 17.8063C12.7288 17.8506 12.4877 18.1597 12.5483 18.4843C12.5935 18.779 12.8493 19 13.1503 19H13.2408C13.2997 18.9927 13.362 18.982 13.4244 18.9712C13.4899 18.9599 13.5554 18.9487 13.6171 18.9413C13.9481 18.8826 14.1592 18.558 14.0986 18.2339C14.0381 17.8949 13.7071 17.6888 13.3761 17.7475C13.3247 17.7548 13.2734 17.7656 13.2219 17.7763L13.2219 17.7763L13.2219 17.7763ZM15.7435 16.7107C15.7857 16.6769 15.8279 16.6431 15.8741 16.6131C16.1451 16.4215 16.5214 16.4658 16.7318 16.7162C16.9429 16.9665 16.8976 17.3499 16.6266 17.5559C16.536 17.6296 16.4308 17.7033 16.3256 17.7769C16.2057 17.8656 16.0851 17.8949 15.9646 17.8949C15.7841 17.8949 15.5883 17.8069 15.4678 17.6446C15.272 17.3648 15.3473 16.9965 15.6183 16.8048C15.6624 16.7757 15.7029 16.7432 15.7435 16.7107ZM10.4609 17.6117L10.4609 17.6117L10.4608 17.6117C10.4153 17.5979 10.3695 17.5841 10.3206 17.5702C10.0043 17.4672 9.65859 17.6439 9.55275 17.9535C9.44751 18.2632 9.628 18.6016 9.94431 18.7052C10.0636 18.7491 10.183 18.7783 10.3017 18.8074L10.3053 18.8083C10.3653 18.8232 10.4105 18.8232 10.4711 18.8232C10.7421 18.8232 10.9826 18.6465 11.0578 18.3812C11.1484 18.0865 10.9526 17.7475 10.6216 17.6589V17.6588C10.5653 17.6431 10.5133 17.6275 10.4609 17.6117ZM15.0317 13.0911L13.5112 12.1483C13.5112 12.1262 13.5187 12.1077 13.5262 12.0893C13.5337 12.0709 13.5412 12.0525 13.5412 12.0303C13.5412 11.5146 13.2402 11.0875 12.804 10.8665V8.53829C12.804 8.19928 12.5329 7.93394 12.1866 7.93394C11.8403 7.93394 11.5693 8.19928 11.5693 8.53829V10.8808C11.1331 11.1018 10.832 11.5289 10.832 12.0446C10.832 12.7664 11.4341 13.3707 12.1866 13.3707C12.4424 13.3707 12.6534 13.2821 12.8486 13.1647L14.3691 14.1075C14.4743 14.1662 14.5795 14.1961 14.7001 14.1961C14.8958 14.1961 15.1063 14.0931 15.2115 13.9164C15.4079 13.6367 15.3174 13.2683 15.0316 13.091L15.0317 13.0911ZM12.1867 12.5017C11.931 12.5017 11.7052 12.2957 11.7052 12.0303C11.7052 11.7799 11.9157 11.5589 12.1867 11.5589C12.4425 11.5589 12.6682 11.765 12.6682 12.0303C12.6682 12.2957 12.4425 12.5017 12.1867 12.5017Z", fill: props.color ?? props.htmlColor ?? "#0070E1" }),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: props.color ?? props.htmlColor ?? "#0070E1" })));

const TimeIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 32 32" }, props),
    React.createElement("path", { d: "M17.4998 7.75H14.4998C14.0873 7.75 13.7498 8.0875 13.7498 8.5C13.7498 8.9125 14.0873 9.25 14.4998 9.25H17.4998C17.9123 9.25 18.2498 8.9125 18.2498 8.5C18.2498 8.0875 17.9123 7.75 17.4998 7.75ZM15.9998 17.5C16.4123 17.5 16.7498 17.1625 16.7498 16.75V13.75C16.7498 13.3375 16.4123 13 15.9998 13C15.5873 13 15.2498 13.3375 15.2498 13.75V16.75C15.2498 17.1625 15.5873 17.5 15.9998 17.5ZM21.2723 12.5425L21.8348 11.98C22.1198 11.695 22.1273 11.2225 21.8348 10.93L21.8273 10.9225C21.5348 10.63 21.0698 10.6375 20.7773 10.9225L20.2148 11.485C19.0523 10.555 17.5898 10 15.9998 10C12.3998 10 9.33983 12.97 9.24983 16.57C9.15233 20.38 12.2048 23.5 15.9998 23.5C19.7348 23.5 22.7498 20.4775 22.7498 16.75C22.7498 15.16 22.1948 13.6975 21.2723 12.5425ZM15.9998 22C13.0973 22 10.7498 19.6525 10.7498 16.75C10.7498 13.8475 13.0973 11.5 15.9998 11.5C18.9023 11.5 21.2498 13.8475 21.2498 16.75C21.2498 19.6525 18.9023 22 15.9998 22Z", fill: props.color ?? props.htmlColor ?? "#70D351" }),
    React.createElement("path", { opacity: "0.1", fillRule: "evenodd", clipRule: "evenodd", d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z", fill: props.color ?? props.htmlColor ?? "#70D351" })));

const ZoomIcon = (props) => (React.createElement(core.SvgIcon, Object.assign({ viewBox: "0 0 508 508" }, props),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "a" },
            React.createElement("circle", { cx: "254.1", cy: "254.1", r: "242", fill: "none" })),
        React.createElement("clipPath", { id: "b" },
            React.createElement("circle", { cx: "254.1", cy: "254.1", r: "237.2", fill: "none" })),
        React.createElement("clipPath", { id: "c" },
            React.createElement("circle", { cx: "254.1", cy: "254.1", r: "218.2", fill: "none" })),
        React.createElement("clipPath", { id: "d" },
            React.createElement("path", { d: "M321,225.88l61.53-45c5.38-4.39,9.47-3.39,9.47,4.68V322.71c0,9.07-5.09,8.07-9.47,4.68l-61.53-45ZM112,185.71V288.17A42,42,0,0,0,154.12,330h149.2a7.74,7.74,0,0,0,7.68-7.61V219.83A42,42,0,0,0,268.88,178H119.68A7.83,7.83,0,0,0,112,185.71Z", fill: "none" }))),
    React.createElement("g", { clipPath: "url(#a)" },
        React.createElement("path", { d: "M0,0H508V508H0Z", fill: "#e5e5e4" })),
    React.createElement("g", { clipPath: "url(#b)" },
        React.createElement("path", { d: "M5,5H503V503H5Z", fill: "#fff" })),
    React.createElement("g", { clipPath: "url(#c)" },
        React.createElement("path", { d: "M24,24H484V484H24Z", fill: "#4a8cff" })),
    React.createElement("g", { clipPath: "url(#d)" },
        React.createElement("path", { d: "M100,166H404V342H100Z", fill: "#fff" }))));

const useStyle = core.makeStyles((theme) => core.createStyles({
    noItemsIcon: {
        height: "11rem",
        margin: theme.spacing(1),
    },
    noItemsText: {
        opacity: 0.7,
        textAlign: "center",
    },
}));

let ImFineError = /** @class */ (() => {
    class ImFineError extends Error {
        constructor({ message, errorCode = HTTPStatusCodes.INTERNAL_SERVER_ERROR, error = HTTPStatusCodes.getStatusText(HTTPStatusCodes.INTERNAL_SERVER_ERROR), stack, statusCode = HTTPStatusCodes.INTERNAL_SERVER_ERROR, } = {}) {
            super();
            this.message = "";
            if (typeof message === "string") {
                this.message = message;
                this.errorCode = errorCode || HTTPStatusCodes.INTERNAL_SERVER_ERROR;
                this.error = error;
                this.stack = stack;
                this.statusCode = statusCode || HTTPStatusCodes.INTERNAL_SERVER_ERROR;
            }
            else if (message instanceof ImFineError) {
                this.setFromInstance(message);
            }
            else if (message) {
                this.setFromError(message);
            }
            else {
                this.setFromInstance(ImFineError.internalError());
            }
            if (stack) {
                this.stack = `${stack}\n${new Error().stack}`;
            }
            else {
                this.stack = new Error().stack;
            }
            this.name = this.message;
        }
        setFromInstance(objErrorData) {
            this.statusCode = objErrorData.statusCode || HTTPStatusCodes.INTERNAL_SERVER_ERROR;
            this.errorCode = objErrorData.errorCode || HTTPStatusCodes.INTERNAL_SERVER_ERROR;
            this.error =
                objErrorData.error ||
                    HTTPStatusCodes.getStatusText(HTTPStatusCodes.INTERNAL_SERVER_ERROR);
            this.message = objErrorData.message;
            if (objErrorData.stack) {
                this.stack = `${objErrorData.stack}\n${new Error().stack}\n${this.stack}`;
            }
        }
        setFromError(error) {
            this.statusCode = HTTPStatusCodes.INTERNAL_SERVER_ERROR;
            this.errorCode = HTTPStatusCodes.INTERNAL_SERVER_ERROR;
            this.error = HTTPStatusCodes.getStatusText(HTTPStatusCodes.INTERNAL_SERVER_ERROR);
            this.message = error.message;
            if (error.stack) {
                this.stack = `${error.stack}\n${new Error().stack}\n${this.stack}`;
            }
        }
        toPublicObject() {
            return {
                statusCode: this.statusCode,
                errorCode: this.errorCode,
                error: this.error,
                message: this.message,
            };
        }
        toPrivateObject() {
            return {
                statusCode: this.statusCode,
                errorCode: this.errorCode,
                error: this.error,
                message: this.message,
                stack: this.stack,
            };
        }
        static notFoundGeneric(message) {
            return new ImFineError({
                ...ImFineError.ERROR_NOT_FOUND,
                message: message || ImFineError.ERROR_NOT_FOUND.message,
            });
        }
        static resourceNotFound(strResourceName, nResourceID) {
            return ImFineError.resourceWithKeyNotFound(strResourceName, "ID", parseInt(nResourceID, 10));
        }
        static resourceWithKeyNotFound(strResourceName, nResourceKeyName, mxResourceKeyValue) {
            const objError = this.ERROR_RESOURCE_NOT_FOUND;
            objError.message = `${strResourceName} with ${nResourceKeyName} #${JSON.stringify(mxResourceKeyValue)} not found.`;
            return new ImFineError(objError);
        }
        static multipleResults(message) {
            return new ImFineError({
                ...ImFineError.ERROR_MULTIPLE_RESOURCES_FOUND,
                message: message || ImFineError.ERROR_MULTIPLE_RESOURCES_FOUND.message,
            });
        }
        static multipleResultsForID(strResourceName, nResourceID) {
            return ImFineError.multipleResultsForKey(strResourceName, "ID", parseInt(nResourceID, 10));
        }
        static multipleResultsForKey(strResourceName, nResourceKeyName, mxResourceKeyValue) {
            const objError = this.ERROR_MULTIPLE_RESOURCES_FOUND;
            objError.message = `Multiple results found for ${strResourceName} with ${nResourceKeyName} #${JSON.stringify(mxResourceKeyValue)}.`;
            return new ImFineError(objError);
        }
        static notImplemented(message) {
            return new ImFineError({
                ...ImFineError.ERROR_NOT_IMPLEMENTED,
                message: message || ImFineError.ERROR_NOT_IMPLEMENTED.message,
            });
        }
        static methodNotAllowed(message) {
            return new ImFineError({
                ...ImFineError.ERROR_METHOD_NOT_ALLOWED,
                message: message || ImFineError.ERROR_METHOD_NOT_ALLOWED.message,
            });
        }
        static invalidSessionData(message) {
            return new ImFineError({
                ...ImFineError.ERROR_INVALID_SESSION_DATA,
                message: message || ImFineError.ERROR_INVALID_SESSION_DATA.message,
            });
        }
        static invalidParameter(message) {
            return new ImFineError({
                ...ImFineError.ERROR_INVALID_PARAMETER,
                message: message || ImFineError.ERROR_INVALID_PARAMETER.message,
            });
        }
        static forbidden(message) {
            return new ImFineError({
                ...ImFineError.ERROR_FORBIDDEN,
                message: message || ImFineError.ERROR_FORBIDDEN.message,
            });
        }
        static internalError(message) {
            return new ImFineError({
                ...ImFineError.ERROR_GENERIC_INTERNAL_ERROR,
                message: message || ImFineError.ERROR_GENERIC_INTERNAL_ERROR.message,
            });
        }
        static forbiddenNoAuthToken(message) {
            return new ImFineError({
                ...this.ERROR_FORBIDDEN_NO_AUTH_TOKEN,
                message: message || ImFineError.ERROR_FORBIDDEN_NO_AUTH_TOKEN.message,
            });
        }
        static emailAlreadyInUse(message) {
            return this.invalidParameter("Email already in use."); //TODO
        }
        static emailNotSet(message) {
            return this.invalidParameter("Email not set."); //TODO
        }
        static invalidCredentials(message) {
            return new ImFineError({
                ...ImFineError.ERROR_INVALID_CREDENTIALS,
                message: message || ImFineError.ERROR_INVALID_CREDENTIALS.message,
            });
        }
        static unauthorized(message) {
            return new ImFineError({
                ...this.ERROR_UNAUTHORIZED,
                message: message || ImFineError.ERROR_UNAUTHORIZED.message,
            });
        }
        static invalidCookie(message) {
            return this.unauthorized(message || "Invalid authentication cookies.");
        }
        static invalidAccessToken(message) {
            return this.unauthorized(message || "Invalid access token.");
        }
        static requestTimeout(message) {
            return new ImFineError({
                ...this.ERROR_REQUEST_TIMEOUT,
                message: message || ImFineError.ERROR_REQUEST_TIMEOUT.message,
            });
        }
    }
    ImFineError.ERROR_GENERIC_INTERNAL_ERROR = {
        statusCode: HTTPStatusCodes.INTERNAL_SERVER_ERROR,
        errorCode: 500,
        error: "Internal Server Error",
        message: "Internal error.",
    };
    ImFineError.ERROR_NOT_FOUND = {
        statusCode: HTTPStatusCodes.NOT_FOUND,
        errorCode: 404,
        error: "Not Found",
        message: "Not found.",
    };
    ImFineError.ERROR_RESOURCE_NOT_FOUND = {
        statusCode: HTTPStatusCodes.NOT_FOUND,
        errorCode: 404,
        error: "Resource Not Found",
        message: "RESOURCE with ID #RESOURCE_ID not found.",
    };
    ImFineError.ERROR_UNAUTHORIZED = {
        statusCode: HTTPStatusCodes.UNAUTHORIZED,
        errorCode: 401,
        error: "Unauthorized",
        message: "Unauthorized.",
    };
    ImFineError.ERROR_INVALID_CREDENTIALS = {
        ...ImFineError.ERROR_UNAUTHORIZED,
        errorCode: 401,
        message: "Invalid credentials.",
    };
    ImFineError.ERROR_INVALID_SESSION_DATA = {
        statusCode: HTTPStatusCodes.INTERNAL_SERVER_ERROR,
        errorCode: 500,
        error: "Invalid Session Data",
        message: "Invalid session data.",
    };
    ImFineError.ERROR_FORBIDDEN = {
        statusCode: HTTPStatusCodes.FORBIDDEN,
        errorCode: 403,
        error: "Forbidden",
        message: "You are not authorized to perform this action.",
    };
    ImFineError.ERROR_FORBIDDEN_NO_AUTH_TOKEN = {
        statusCode: HTTPStatusCodes.FORBIDDEN,
        errorCode: 403,
        error: "Forbidden",
        message: "You are not authorized to perform this action. You must include the X-Auth-Token header.",
    };
    ImFineError.ERROR_INVALID_PARAMETER = {
        statusCode: HTTPStatusCodes.BAD_REQUEST,
        errorCode: 422,
        error: "Invalid Parameter",
        message: "Invalid parameter.",
    };
    ImFineError.ERROR_NOT_IMPLEMENTED = {
        statusCode: HTTPStatusCodes.NOT_IMPLEMENTED,
        errorCode: 501,
        error: "Not Implemented",
        message: "Method not implemented.",
    };
    ImFineError.ERROR_METHOD_NOT_ALLOWED = {
        statusCode: HTTPStatusCodes.METHOD_NOT_ALLOWED,
        errorCode: 405,
        error: "Method not allowed",
        message: "Method not allowed.",
    };
    ImFineError.ERROR_MULTIPLE_RESOURCES_FOUND = {
        statusCode: HTTPStatusCodes.INTERNAL_SERVER_ERROR,
        errorCode: 1001,
        error: "Multiple results found",
        message: "Multiple results found for RESOURCE with ID #RESOURCE_ID.",
    };
    ImFineError.ERROR_REQUEST_TIMEOUT = {
        statusCode: HTTPStatusCodes.REQUEST_TIMEOUT,
        errorCode: 1408,
        error: "REQUEST_TIMEOUT",
        message: "Request timeout.",
    };
    return ImFineError;
})();

const useStyles$1 = core.makeStyles((theme) => ({
    icon: {
        height: "11rem",
        width: "100%",
        margin: theme.spacing(1),
    },
}));

const EMPTY_UUID = "empty_uuid";
const DATE_ISO8601_ZULU = "YYYY-MM-DDTHH:mm:ss\\Z";

const getPseudoRandomString = ({ length, includedChars = "", randomMaxLength = 1000, }) => {
    const stringLength = length ?? Math.floor(Math.random() * randomMaxLength);
    let result = "";
    const characters = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789${includedChars}`;
    const charactersLength = characters.length;
    for (let i = 0; i < stringLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
function getRandomArrayElement(arrWithElements) {
    // const min = 0;
    const max = arrWithElements.length;
    const randomNumber = Math.min(Math.floor((Math.random() * 100) % max), max);
    return arrWithElements[randomNumber];
}
function getRandomObjectKey(data, skipKeys) {
    const keys = Object.keys(data).filter((it) => !skipKeys || !skipKeys.map((k) => String(k)).includes(String(it)));
    return getRandomArrayElement(keys);
}
function getRandomObjectValue(data, skipKeys) {
    const key = getRandomObjectKey(data, skipKeys);
    return data[key];
}
/**
 * Fisher-Yates (aka Knuth) Shuffle
 * https://bost.ocks.org/mike/shuffle/
 *
 * @param array
 */
function shuffleArray(array) {
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}

function defaultMultiplyData(it) {
    return [{ ...it }];
}
function multiplyDataCreatedTimestamp(it) {
    return [
        {
            ...it,
            uuid: getPseudoRandomString({ length: 36 }),
            createdTimestamp: moment(it.createdTimestamp)
                .add(Math.random() * 1000, "days")
                .format(DATE_ISO8601_ZULU),
        },
    ];
}
function multiplyData({ data, transformData = defaultMultiplyData, iterations = 5, resultCount, }) {
    let result = [];
    const multiplyIterations = (resultCount ? Math.ceil(resultCount / data.length) : iterations) ?? 1;
    for (let i = 0; i < multiplyIterations; i++) {
        result.push(...data.flatMap(transformData));
    }
    if (resultCount) {
        result = result.slice(0, resultCount);
    }
    console.debug(`multiplyData -> from ${data.length} to ${result.length}`);
    return result;
}

const hasEnvVariable = (envVarName) => {
    return (typeof process.env[envVarName] === "string" &&
        process.env[envVarName].trim().length > 0);
};
const getEnvVariable = (envVarName) => {
    if (!hasEnvVariable(envVarName)) {
        throw new Error(`Invalid process.env.${envVarName}`);
    }
    return process.env[envVarName].trim();
};
const getEnvBoolean = (envVarName) => {
    if (typeof process.env[envVarName] !== "string" ||
        process.env[envVarName].trim().length === 0 ||
        process.env[envVarName].trim() === "false") {
        return false;
    }
    return process.env[envVarName].trim() === "true";
};
const getEnvURL = (envURL) => {
    let returnURL;
    const url = new URL(envURL);
    if (process.env.REACT_APP_API_SAME_ORIGIN === "true") {
        returnURL = `${window.location.origin}${url.pathname}${url.search}${url.hash}`;
    }
    else if (process.env.REACT_APP_API_SAME_HOST === "true") {
        returnURL = `${url.protocol}//${window.location.hostname}:${url.port}${url.pathname}${url.search}${url.hash}`;
    }
    else {
        returnURL = envURL.trim();
    }
    if (!returnURL) {
        throw new Error(`Env URL cannot be parsed: ${envURL}.`);
    }
    return returnURL;
};

function errorsToMap(errors) {
    const errorsMap = {};
    if (errors && errors.length) {
        errors.forEach((err) => {
            errorsMap[err.fieldName] = err.message;
        });
    }
    return errorsMap;
}

function getImageURL(imageURL, options = {}) {
    if (!imageURL) {
        return undefined;
    }
    if (imageURL.includes("localhost") || !hasEnvVariable("NEXT_PUBLIC_THUMBOR_URL")) {
        return imageURL;
    }
    let thumborURL = getEnvVariable("NEXT_PUBLIC_THUMBOR_URL");
    thumborURL += "/unsafe";
    if (options.size) {
        thumborURL += `/${options.size.width}x${options.size.height}`;
    }
    if (options.smart) {
        thumborURL += "/smart";
    }
    if (options.filters) {
        thumborURL += `/filters:${Object.entries(options.filters)
            .map(([filter, value]) => {
            switch (filter) {
                case "grayscale":
                    return value ? "grayscale()" : "";
                default:
                    return `${filter}:(${value})`;
            }
        })
            .join(":")}`;
    }
    return `${thumborURL}/${imageURL}`;
}

async function runBatchRequestsInParallel({ listParams, requestFn, maxItems = 100, uniqueIndexes = true, }) {
    const list = uniqueIndexes ? Array.from(new Set(listParams)) : listParams;
    if (list.length < maxItems) {
        return requestFn(list);
    }
    const promises = [];
    let currentIndex = 0;
    do {
        const currentBatch = list.slice(currentIndex, currentIndex + maxItems);
        promises.push(requestFn(currentBatch));
        currentIndex += maxItems;
    } while (currentIndex < list.length);
    const allResults = await Promise.all(promises);
    return allResults.reduce((acc, results) => [
        ...(Array.isArray(acc) ? acc : [acc]),
        ...(Array.isArray(results) ? results : [results]),
    ], []);
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function sortByFieldAccessors(order, ...fieldAccessors) {
    return (object1, object2) => {
        for (const fieldAccessor of fieldAccessors) {
            if (!fieldAccessor(object1) && !fieldAccessor(object2)) {
                continue;
            }
            if (!fieldAccessor(object1) || fieldAccessor(object1) < fieldAccessor(object2)) {
                return order === "asc" ? -1 : 1;
            }
            else if (!fieldAccessor(object2) ||
                fieldAccessor(object1) > fieldAccessor(object2)) {
                return order === "asc" ? 1 : -1;
            }
        }
        return 0;
    };
}
function sortByFields(order, ...fieldNames) {
    return (object1, object2) => {
        for (const fieldName of fieldNames) {
            if (object1[fieldName] < object2[fieldName]) {
                return order === "asc" ? -1 : 1;
            }
            else if (object1[fieldName] > object2[fieldName]) {
                return order === "asc" ? 1 : -1;
            }
        }
        return 0;
    };
}
function sortByEachField(fields) {
    return (object1, object2) => {
        for (const [fieldName, order] of Object.entries(fields)) {
            const field = fieldName;
            if (object1[field] < object2[field]) {
                return order === "asc" ? -1 : 1;
            }
            else if (object1[field] > object2[field]) {
                return order === "asc" ? 1 : -1;
            }
        }
        return 0;
    };
}

// tslint:disable-next-line: max-line-length
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript#answer-37511463
const escapeDiacritics = (text) => {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
const transformForSearch = (text) => {
    return escapeDiacritics(text.toLowerCase());
};
const formatName = (text) => {
    return text
        .trim()
        .split(" ")
        .filter((textPart) => textPart.length > 0)
        .map((textPart) => `${textPart[0].toUpperCase()}${textPart.substr(1).toLowerCase()}`)
        .join(" ");
};
const textSearchIncludes = (text, search) => {
    return transformForSearch(text).includes(transformForSearch(search));
};
const capitalizeFirst = (text) => {
    if (text.length === 0) {
        return text;
    }
    return `${text[0].toUpperCase()}${text.substr(1)}`;
};

const diffKeys = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
];
const diffKeyToRelativeTimeKey = (key, value) => {
    switch (key) {
        case "months":
            return value === 1 ? "M" : "MM";
        default:
            return (value === 1
                ? key[0]
                : Array.from({ length: 2 }, () => key[0]).join(""));
    }
};
const humanizeTimeDiff = (start, end, options) => {
    let diff = moment(end).diff(start, "minute", options?.precise ?? false);
    if (options?.abs) {
        diff = Math.abs(diff);
    }
    const duration = moment.duration(diff, "minute");
    if (options?.only) {
        const funName = `as${options.only[0].toUpperCase()}${options.only.substring(1)}`;
        const value = duration[funName](); // ex: asMinutes
        return moment
            .localeData()
            .relativeTime(value, options?.withoutSuffix ?? true, diffKeyToRelativeTimeKey(options.only, value), options?.isFuture ?? false);
    }
    const texts = diffKeys.map((key, index) => {
        const value = duration[key]();
        const relativeKey = diffKeyToRelativeTimeKey(key, value);
        if ((!options?.includeSeconds && key === "seconds") ||
            (!options?.includeWeeks && key === "weeks")) {
            return "";
        }
        if (value >= 1) {
            return moment
                .localeData()
                .relativeTime(value, options?.withoutSuffix ?? true, relativeKey, options?.isFuture ?? false);
        }
        return "";
    });
    return texts.filter((it) => it.length > 0).join(", ");
};
const changeLocale = async (newLanguage) => {
    if (moment.locale() !== newLanguage) {
        if (newLanguage === "en") {
            moment.locale(newLanguage);
        }
        else {
            const momentLocale = await Promise.resolve().then(function () { return _interopNamespace(require(`moment/locale/${newLanguage}`)); });
            moment.updateLocale(newLanguage, momentLocale);
        }
    }
};
const getUTCTime = (time = undefined, format = DATE_ISO8601_ZULU) => {
    return moment(time).utc().format(format);
};
const getLocalDateTimeAsString = (time = undefined, format = DATE_ISO8601_ZULU) => {
    return moment(time).local().format(format);
};
const getLocalDateTimeAsDate = (time = undefined) => {
    return moment(time).local().toDate();
};
const getLocalDateTimeAsFormattedString = (time = undefined) => {
    return moment(time).format("LLL");
};
const minutesToTime = (minutes) => {
    const duration = moment.duration(minutes, "minutes");
    return `${duration.get("hours").toString().padStart(2, "0")}:${duration
        .get("minutes")
        .toString()
        .padStart(2, "0")}`;
};
const timeToMinutes = (duration) => {
    return moment.duration(duration).asMinutes();
};

const translationTransform = (translationData, languagesCodes) => {
    // console.log("HERE", translationData, languagesCodes);
    const customTranslation = translationData;
    const returnTranslations = {};
    for (const [label, value] of Object.entries(customTranslation)) {
        returnTranslations[label] = languagesCodes.map((languageCode) => {
            const language = languageCode;
            return value[language] ? value[language].value : getNoTextTranslation(label, language);
        });
    }
    // console.log("HERE2", returnTranslations);
    return returnTranslations;
};
const getNoTextTranslation = (translationKey, language) => {
    return `[NO TEXT - language: ${language}, key: ${translationKey}]`;
};
const getRequiredFieldTranslation = (translationFunction, fieldTranslationID) => {
    return translationFunction("field_is_required", {
        field: translationFunction(fieldTranslationID),
    });
};
const getDefaultPlaceholderForLabelKey = (translationFunction, labelTranslationKey, labelTranslationData) => {
    return translationFunction("default_select_placeholder_for_label", {
        label: translationFunction(labelTranslationKey, labelTranslationData).toLowerCase(),
    });
};
const getDefaultPlaceholderForLabel = (translationFunction, labelValue) => {
    return translationFunction("default_select_placeholder_for_label", {
        label: labelValue.trim().toLowerCase(),
    });
};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

// Copyright Joyent, Inc. and other Node contributors.

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var decode = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

// Copyright Joyent, Inc. and other Node contributors.

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

var encode = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring = createCommonjsModule(function (module, exports) {

exports.decode = exports.parse = decode;
exports.encode = exports.stringify = encode;
});
var C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring_1 = C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring.decode;
var C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring_2 = C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring.parse;
var C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring_3 = C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring.encode;
var C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring_4 = C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring.stringify;

function arrayToUUIDMap(array) {
    const map = new Map();
    for (const element of array) {
        map.set(element.uuid, element);
    }
    return map;
}
function arrayToPropertyList(array, key) {
    return array.map((element) => element[key]);
}
function roundToPrecision(float, digits) {
    const rounded = Math.pow(10, digits);
    return Math.round(float * rounded) / rounded;
}
const urlQueryToObject = (query) => {
    query = query || window.location.search;
    query = query.replace("?", "");
    if (query.trim().length === 0) {
        return {};
    }
    try {
        return JSON.parse('{"' +
            decodeURI(query.replace("?", "").replace(/&/g, '","').replace(/=/g, '":"')) +
            '"}');
    }
    catch (error) {
        console.error(error);
        return {};
    }
};
const objectToQueryString = (queryObject, includeDelimiter = true) => {
    if (!queryObject) {
        return "";
    }
    return C__Program_Files__x86__Jenkins_workspace_uiLibs_master_node_modules_querystring.stringify(queryObject);
};
const stopEventPropagation = (event) => event.stopPropagation();

exports.AddressIcon = AddressIcon;
exports.DATE_ISO8601_ZULU = DATE_ISO8601_ZULU;
exports.EMPTY_UUID = EMPTY_UUID;
exports.ExperienceIcon = ExperienceIcon;
exports.FbIcon = FbIcon;
exports.GoogleCalendarIcon = GoogleCalendarIcon;
exports.GoogleCalendarIconOld = GoogleCalendarIconOld;
exports.GoogleMeetIcon = GoogleMeetIcon;
exports.GoogleMeetIconOld = GoogleMeetIconOld;
exports.IconText = IconText;
exports.ImFineError = ImFineError;
exports.LanguagesIcon = LanguagesIcon;
exports.MailIcon = MailIcon;
exports.OnlineIcon = OnlineIcon;
exports.PhoneIcon = PhoneIcon;
exports.PinIcon = PinIcon;
exports.PriceIcon = PriceIcon;
exports.RatingIcon = RatingIcon;
exports.SiteIcon = SiteIcon;
exports.SkypeIcon = SkypeIcon;
exports.SpecialistsIcon = SpecialistsIcon;
exports.TimeAgoIcon = TimeAgoIcon;
exports.TimeIcon = TimeIcon;
exports.ZoomIcon = ZoomIcon;
exports.arrayToPropertyList = arrayToPropertyList;
exports.arrayToUUIDMap = arrayToUUIDMap;
exports.capitalizeFirst = capitalizeFirst;
exports.changeLocale = changeLocale;
exports.defaultMultiplyData = defaultMultiplyData;
exports.diffKeys = diffKeys;
exports.errorsToMap = errorsToMap;
exports.escapeDiacritics = escapeDiacritics;
exports.formatName = formatName;
exports.getDefaultPlaceholderForLabel = getDefaultPlaceholderForLabel;
exports.getDefaultPlaceholderForLabelKey = getDefaultPlaceholderForLabelKey;
exports.getEnvBoolean = getEnvBoolean;
exports.getEnvURL = getEnvURL;
exports.getEnvVariable = getEnvVariable;
exports.getImageURL = getImageURL;
exports.getLocalDateTimeAsDate = getLocalDateTimeAsDate;
exports.getLocalDateTimeAsFormattedString = getLocalDateTimeAsFormattedString;
exports.getLocalDateTimeAsString = getLocalDateTimeAsString;
exports.getNoTextTranslation = getNoTextTranslation;
exports.getPseudoRandomString = getPseudoRandomString;
exports.getRandomArrayElement = getRandomArrayElement;
exports.getRandomObjectKey = getRandomObjectKey;
exports.getRandomObjectValue = getRandomObjectValue;
exports.getRequiredFieldTranslation = getRequiredFieldTranslation;
exports.getUTCTime = getUTCTime;
exports.hasEnvVariable = hasEnvVariable;
exports.humanizeTimeDiff = humanizeTimeDiff;
exports.minutesToTime = minutesToTime;
exports.multiplyData = multiplyData;
exports.multiplyDataCreatedTimestamp = multiplyDataCreatedTimestamp;
exports.objectToQueryString = objectToQueryString;
exports.roundToPrecision = roundToPrecision;
exports.runBatchRequestsInParallel = runBatchRequestsInParallel;
exports.shuffleArray = shuffleArray;
exports.sleep = sleep;
exports.sortByEachField = sortByEachField;
exports.sortByFieldAccessors = sortByFieldAccessors;
exports.sortByFields = sortByFields;
exports.stopEventPropagation = stopEventPropagation;
exports.textSearchIncludes = textSearchIncludes;
exports.timeToMinutes = timeToMinutes;
exports.transformForSearch = transformForSearch;
exports.translationTransform = translationTransform;
exports.urlQueryToObject = urlQueryToObject;
